module.exports = __webpack_public_path__ + "static/card2-267d3f5b11b233e26b0c28a848851756.svg";